// extracted by mini-css-extract-plugin
module.exports = {"cardImage":"cardImage-module--cardImage--2d3Cf"};